import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=7c350000"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c350000')) {
      api.createRecord('7c350000', component.options)
    } else {
      api.reload('7c350000', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=7c350000", function () {
      api.rerender('7c350000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/conversation/dialog-form-wrapper.vue"
export default component.exports